<template>
  <!-- 首页搜索页面 -->
  <div class="searchPage">
    <!-- 头部tab -->
    <section class="headWrap">
      <div c :class="{ searchBox: true, noBottom: !isShowTab }">
        <van-search
          v-model="searchValue"
          :clearable="false"
          show-action
          background="#f5f5f5"
          :placeholder="placeholder"
          @search="onSearch"
          @update:model-value="hasSeach = false"
        >
          <template #action>
            <div @click="onSearch" class="searchBtn">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="statusTypeTabBox" v-if="!isFirst && isShowTab">
        <Tab
          :data="statusTypeTab"
          :active="statusActive"
          @click="clickStatusType"
          :activeStyle="'color:#3088c5;font-size:15px;'"
          :style="'color:#666;font-size:15px'"
        />
      </div>
    </section>

    <!-- 产品列表 -->
    <section :class="['listWrap', isShowTab ? '' : 'miniTop']">
      <!-- 产品列表 -->
      <section v-if="statusActive === 0">
        <van-divider
          v-if="!productData.length && !productLoading && searchValue && searchValue.trim() && hasSeach"
          dashed
          :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }"
          >很遗憾，没有找到相关结果
        </van-divider>
        <van-list
          v-model:loading="productLoading"
          :finished="productFinished"
          :finished-text="productData.length ? '没有更多了' : ''"
          @load="getProductData"
          direction="down"
        >
          <template v-for="item in productData" :key="item.id" class="tyreCard">
            <TyreCard :datas="item" @link="toDetail(item)" />
          </template>
        </van-list>
      </section>
      <!-- 计划列表 -->
      <section v-if="statusActive === 1">
        <van-divider
          v-if="!loyaltyData.length && !loyaltyLoading && searchValue && searchValue.trim() && hasSeach"
          dashed
          :style="{ color: '#999', borderColor: '#f5f5f5', padding: '0 16px' }"
          >很遗憾，没有找到相关结果
        </van-divider>
        <van-list
          v-model:loading="loyaltyLoading"
          :finished="loyaltyFinished"
          :finished-text="loyaltyData.length ? '没有更多了' : ''"
          @load="getLoyaltyData"
          direction="down"
        >
          <LoyaltyCard v-if="loyaltyData.length" :planList="loyaltyData" />
        </van-list>
      </section>
    </section>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, nextTick, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'vant'
import Tab from '@/components/order/Tab'
import LoyaltyCard from '@/components/plan/LoyaltyCard'
import TyreCard from '@/components/tyre/TyreCard'
import { getLoyaltyPlanListByKeyword } from '@/api/plan'
import { getTyresListByKeyword } from '@/api/tyre'
import { setSession, getSession, backTop } from '@/util'
import _ from 'lodash'
import { useStore } from 'vuex'

export default {
  name: 'searchPage',
  components: {
    Tab,
    LoyaltyCard,
    TyreCard
  },
  setup() {
    let route = useRoute()
    let router = useRouter()
    let store = useStore()
    let { from } = route.query
    let state = reactive({
      statusActive: 0,
      hasClickBtn: false,
      statusTypeTab: [
        { text: '轮胎', id: 0 },
        { text: '致友计划', id: 1 }
      ],
      searchValue: '',
      isFirst: true,
      from,
      placeholder: '',
      scrumPlaceholder: '请输入轮胎品牌规格参数或其他商品名称',
      tyrePlaceholder: '输入配件号/规格/品牌/车型搜索轮胎',
      isShowTab: from !== 'tyre',
      hasSeach: false,
      productData: [], // 产品数据
      loyaltyData: [], // 计划数据
      productLoading: false,
      productCanLoad: false,
      loyaltyLoading: false,
      loyaltyCanLoad: false,
      productFinished: false,
      loyaltyFinished: false,
      productPageNo: 1,
      loyaltyPageNo: 1,
      pageSize: 10
    })
    // 切换订单状态
    const clickStatusType = v => {
      state.statusActive = v.id
    }
    // 获取产品数据
    const getProductData = async (isInit = false) => {
      if (!state.searchValue || !state.searchValue.trim()) {
        state.searchValue = ''
        state.productLoading = false
        state.hasSeach = false
        return
      }
      // 防止反复加载，不要删
      if (!state.productCanLoad) return
      state.productCanLoad = false
      try {
        let pramas = {
          keyword: state.searchValue,
          pageNo: state.productPageNo,
          pageSize: state.pageSize
        }
        // console.log("getProductData---------------", pramas);
        state.productLoading = true
        let { list = [], pagination = {} } = await getTyresListByKeyword(pramas)
        const res = list ? list.map(item => ({ ...item, has_commodity: true })) : []
        state.productFinished = pagination.pageNo === pagination.pageCount
        state.productData = isInit ? res : state.productData.concat(res)
        state.productLoading = false
        state.productCanLoad = true
        !state.hasSeach && (state.hasSeach = true)
        state.productPageNo += pagination.pageNo < pagination.pageCount ? 1 : 0
        nextTick(() => {
          autoToggleStatusTab()
        })
      } catch (e) {
        Toast({ message: e.message || '请求产品列表数据失败', position: 'bottom' })
        state.productLoading = false
        state.productCanLoad = false
        state.productFinished = true
        nextTick(() => {
          autoToggleStatusTab()
        })
      }
    }
    // 获取致友计划数据
    const getLoyaltyData = async (isInit = false) => {
      if (!state.searchValue || !state.searchValue.trim()) {
        state.searchValue = ''
        state.loyaltyLoading = false
        state.hasSeach = false
        return
      }
      // 防止反复加载，不要删
      if (!state.loyaltyCanLoad) return
      state.loyaltyCanLoad = false
      try {
        let pramas = {
          keyword: state.searchValue,
          pageNo: state.loyaltyPageNo,
          pageSize: state.pageSize
        }
        // console.log("getLoyaltyData---------------", pramas);
        state.loyaltyLoading = true
        let { list = [], pagination = {} } = await getLoyaltyPlanListByKeyword(pramas)
        state.loyaltyFinished = pagination.pageNo === pagination.pageCount
        state.loyaltyData = isInit ? list : state.loyaltyData.concat(list)
        state.loyaltyLoading = false
        state.loyaltyCanLoad = true
        !state.hasSeach && (state.hasSeach = true)
        state.loyaltyPageNo += pagination.pageNo < pagination.pageCount ? 1 : 0
        nextTick(() => {
          autoToggleStatusTab()
        })
      } catch (e) {
        Toast({ message: e.message || '请求计划列表数据失败', position: 'bottom' })
        state.loyaltyLoading = false
        state.loyaltyCanLoad = false
        state.loyaltyFinished = true
        nextTick(() => {
          autoToggleStatusTab()
        })
      }
    }
    // 重置state参数
    const resetState = async () => {
      // console.log("resetState---------------");
      state.productData = []
      state.loyaltyData = []
      state.loyaltyPageNo = 1
      state.productPageNo = 1
      state.hasSeach = false
      state.productLoading = false
      state.productCanLoad = true
      state.loyaltyLoading = false
      state.loyaltyCanLoad = true
      state.productFinished = false
      state.loyaltyFinished = false
    }
    // 点击搜索
    const onSearch = _.debounce(() => {
      if (!state.searchValue || !state.searchValue.trim()) {
        state.searchValue = ''
        return
      }
      state.isFirst && (state.isFirst = false)
      state.hasClickBtn = true
      backTop()
      resetState()
      nextTick(() => {
        getProductData(true)
        if (state.from !== 'tyre') {
          getLoyaltyData(true)
        }
      })
    }, 800)
    // 根据产品数据，自动切换tab
    const autoToggleStatusTab = () => {
      if (!state.productLoading && !state.loyaltyLoading && state.hasClickBtn) {
        state.hasClickBtn = false
        let tyreLen = state.productData.length
        let loyaltyLen = state.loyaltyData.length
        if (!(tyreLen && loyaltyLen)) {
          if (tyreLen > 0) {
            state.statusActive = 0
          } else if (loyaltyLen > 0) {
            state.statusActive = 1
          }
        }
      }
      if (state.from === 'tyre') {
        state.statusActive = 0
      }
    }
    // 跳转到详情
    const toDetail = item => {
      router.push({ path: '/tyreDetail', query: { tyreId: item.id, event: '轮胎详情' } })
      store.commit('SETCURRENTTYRE', item)
    }

    onMounted(() => {
      let from = route.query.from
      let searchData = getSession('searchData')
      if (!searchData) {
        resetState()
        state.placeholder = from === 'tyre' ? state.tyrePlaceholder : state.scrumPlaceholder
      } else {
        state = Object.assign(state, searchData, { from, isShowTab: from !== 'tyre' })
        if (searchData.from !== from) {
          if (from === 'tyre') {
            state.placeholder = searchData.tyrePlaceholder
          } else {
            state.placeholder = searchData.scrumPlaceholder
            getLoyaltyData(true)
          }
        }
      }
    })
    watch([() => state.productLoading, () => state.loyaltyLoading], ([productLoading, loyaltyLoading]) => {
      if (!productLoading || !loyaltyLoading) {
        setSession('searchData', state)
      }
    })
    return {
      ...toRefs(state),
      onSearch,
      clickStatusType,
      getProductData,
      getLoyaltyData,
      toDetail
    }
  }
}
</script>

<style lang="scss" scoped>
.searchPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
}
.headWrap {
  position: fixed;
  left: 0;
  top: 80px;
  width: 100%;
  padding-bottom: 10px;
  background-color: #f5f5f5;
  z-index: 9999;
  :deep(.van-search) {
    padding: 16px 10px 5px 20px;
  }
  :deep(.van-search__content) {
    border: 1px solid #eee;
    background-color: #fff;
  }
}
.searchBox {
  padding-bottom: 10px;
  background-color: #f5f5f5;
}
.noBottom {
  padding-bottom: 0px !important;
}
.searchBtn {
  color: #666;
}

.statusTypeTabBox {
  padding: 5px 10px 6px;
  background-color: #fff;
  :deep(span) {
    padding: 10px 0;
  }
  :deep(.active span) {
    font-weight: 700;
  }
}
.listWrap {
  margin-top: 125px;
  padding-bottom: 80px;
}
.miniTop {
  margin-top: 65px !important;
}
.tyreCard {
  margin-bottom: 12px;
}
</style>
